'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _isSp = require('../utils/isSp');

var _antd = require('antd');

var _colorUtils = require('../utils/colorUtils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var platformPrimaryDefaultColor = _colors2.default.blue.base;
exports.default = {
  primary: _colors2.default.blue.base,
  primaryAccent: _colors2.default.blue.dark,
  platformPrimary: platformPrimaryDefaultColor,
  spBorder: _colors2.default.gray.sp300,
  spText: _colors2.default.gray.sp900,
  buttonColor: _colors2.default.blue.blue500,
  Navy500: _colors2.default.navy.navy500,
  Navy700: _colors2.default.navy.navy700,
  secondary: _colors2.default.silver.light,
  error: _colors2.default.red.base,
  errorOrange: _colors2.default.orange.base,
  success: _colors2.default.green.base,
  gray: (0, _isSp.isSp)() ? _colors2.default.sp.colorbase : _colors2.default.gray.base,
  hint: _colors2.default.gray.light,
  grayLight: _colors2.default.gray.verylight,
  gold: _colors2.default.gold,
  navy: (0, _isSp.isSp)() ? _colors2.default.sp.background : _colors2.default.blue.navy,
  gray300: _colors2.default.gray.light300,
  gray400: _colors2.default.gray.gray400,
  greenSuccess: _colors2.default.green.success,
  blue500: _colors2.default.blue.blue500,
  HeaderBg: (0, _isSp.isSp)() ? (0, _colorUtils.lightenColor)(platformPrimaryDefaultColor, 0.7) : _colors2.default.navy.navy800,
  notificationHover: (0, _isSp.isSp)() ? platformPrimaryDefaultColor : _colors2.default.navy.navy700,
  BurgerMenu: (0, _isSp.isSp)() ? _colors2.default.sp.colorbase : _colors2.default.blue.blue500,
  SidebarMenu: (0, _isSp.isSp)() ? _colors2.default.sp.white : _colors2.default.navy.navy600,
  TabsBaseColor: (0, _isSp.isSp)() ? _colors2.default.sp.gray : _colors2.default.public.gray,
  TabsActiveColor: (0, _isSp.isSp)() ? _colors2.default.sp.black : _colors2.default.sp.gray,
  ButtonColor: (0, _isSp.isSp)() ? _colors2.default.sp.background : _colors2.default.gray.light300
};